import api from "./api.js";

export default class CouponApi {
  static async create(data) {
    return await api.post(`api/coupon`, data);
  }

  static async getList(params) {
    return await api.get(`api/coupon`, params);
  }

  static async delete(data) {
    return await api.del(`api/coupon`, data);
  }

  static async getById(id) {
    return await api.get(`api/coupon/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/coupon/${id}`, data);
  }

  static async couponCodeList(params) {
    return await api.get(`api/coupon-code`, params);
  }
}
